import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  scope: { name?: string } | null;
};

const ScopeCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.scope?.name && (
      <Tooltip title={row.scope.name}>
        <Typography variant="body2" noWrap>
          {row.scope.name}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default ScopeCell;
